import { createElementVNode as _createElementVNode, openBlock as _openBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-overlay__notebook__panel o-card -card-padding u-bg-color-1 u-color-white" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico c-overlay__notebook__close__icon"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#search-close" })
], -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "o-title-3" }, " Mon carnet ", -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CarnetCart = _resolveComponent("CarnetCart")
  const _component_CarnetLogin = _resolveComponent("CarnetLogin")
  const _component_CarnetRegister = _resolveComponent("CarnetRegister")
  const _component_CarnetForgot = _resolveComponent("CarnetForgot")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = $event => ($options.toggleCarnet())),
      class: "c-overlay__notebook__bg"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = $event => ($options.toggleCarnet())),
        class: "c-overlay__notebook__close"
      }, _hoisted_3),
      _hoisted_4,
      ($data.view=='cart')
        ? (_openBlock(), _createBlock(_component_CarnetCart, {
            key: 0,
            loggedIn: $data.loggedIn,
            posts: $data.posts,
            onToggleView: $options.toggleView,
            onDeletePost: $options.deletePost,
            onLogout: $options.logout
          }, null, 8 /* PROPS */, ["loggedIn", "posts", "onToggleView", "onDeletePost", "onLogout"]))
        : _createCommentVNode("v-if", true),
      ($data.view=='login')
        ? (_openBlock(), _createBlock(_component_CarnetLogin, {
            key: 1,
            onToggleView: $options.toggleView
          }, null, 8 /* PROPS */, ["onToggleView"]))
        : _createCommentVNode("v-if", true),
      ($data.view=='register')
        ? (_openBlock(), _createBlock(_component_CarnetRegister, {
            key: 2,
            onToggleView: $options.toggleView
          }, null, 8 /* PROPS */, ["onToggleView"]))
        : _createCommentVNode("v-if", true),
      ($data.view=='forgot')
        ? (_openBlock(), _createBlock(_component_CarnetForgot, {
            key: 3,
            onToggleView: $options.toggleView
          }, null, 8 /* PROPS */, ["onToggleView"]))
        : _createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}